import defaultCloudPrices from "../../prices/constants/defaultCloudPrices";

import agreementParts from "./agreementParts";
import agreementTypes from "./agreementTypes";

// The defaults for a new cloud agreement.
const cloudAgreementSkeleton = {
	name: "Digital Distribution Service Agreement",
	type: agreementTypes.CLOUD,
	part: agreementParts.PUBLISHER,
	life: 9999,
	prices: Object.values(defaultCloudPrices).map((price) => ({ ...price, approved: false, maxUses: false })),
};

export default cloudAgreementSkeleton;
